module.exports = __webpack_public_path__ + "static/media/G1-14-Sonya-Kamber-cod34.9622d81e.png";